import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then(() => nav("/admin")).catch(() => {});
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Welcome.");
      nav("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally { setLoading(false); }
  };

  const inputCls = "w-full bg-[#151515] border border-[#D8D6D0]/20 px-4 py-3 text-sm text-[#F5F3EF] focus:outline-none focus:border-[#F5F3EF]/70";

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-md nc-card p-10">
        <div className="overline text-[#8C1D30] mb-3">NorthCrest CMS</div>
        <div className="font-serif-display text-4xl mb-8">Sign in.</div>
        <div className="space-y-4">
          <input data-testid="admin-email" required type="email" placeholder="Email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-password" required type="password" placeholder="Password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <button type="submit" disabled={loading} data-testid="admin-submit" className="mt-6 w-full px-6 py-4 bg-[#8C1D30] hover:bg-[#7A1829] text-[#F5F3EF] text-sm uppercase tracking-widest disabled:opacity-50">
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
